import React, { useState, useEffect, useRef } from 'react'; 
import Confetti from 'react-confetti';
import './scss/puzztime.scss';

import Carta from './components/carta';
import Medalla from './components/medalla';
import juegos from './assets/juegos.json';
import { initializeApp } from "firebase/app";
import { getAnalytics,logEvent } from "firebase/analytics";
import { getFirestore ,collection, getDocs ,addDoc, updateDoc, deleteDoc, doc ,getDoc, setDoc} from "firebase/firestore";


import Rand, { PRNG } from 'rand-seed';

import { BrowserRouter, Routes, Route, Link, useLocation, useNavigate, useParams  } from 'react-router-dom';
import Header from './components/Header';
import Victoria from './components/Victoria';
import TiemposCont from './components/TiemposCont';
import ObtFraseFin from './Utilidades';
import AbajoJuegos from './components/AbajoJuegos';



/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* import '@ionic/react/css/palettes/dark.always.css'; */
/* import '@ionic/react/css/palettes/dark.class.css'; */
//import '@ionic/react/css/palettes/dark.system.css';

/* Theme variables */
//import './theme/variables.css';

//setupIonicReact();




/*const App: React.FC = () => (
  <div>
    <h2>Parejas</h2>
    <img src="public/iconos/caballo.png"/>
    <Carta></Carta>
  </div>
);*/

function Parejas() {
const params = useParams();

  const firebaseConfig = {
  apiKey: "AIzaSyCceVPpjBFbA_khqjXABlFtdex6wU6YWPM",
  authDomain: "everyday---deia.firebaseapp.com",
  projectId: "everyday---deia",
  storageBucket: "everyday---deia.firebasestorage.app",
  messagingSenderId: "789110585317",
  appId: "1:789110585317:web:5d01114092fe374edce10c",
  measurementId: "G-N0EC1VFRC5"
};
var rand:Rand;
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const navigate = useNavigate();
const [juegoAct, setJuegoAct]=useState(juegos[1]);

//const [rand,setRand]= useState(new Rand('1'));
const [medalla, setMedalla] = useState(-1);
const [media, setMedia] = useState(-1);
const [porcentajeSuperado, setPortentajeSuperado] = useState(-1);
const [fechaTexto,setFechaTexto]=useState("");
const [fechaAct,setFechaAct]=useState(new Date());
const [confettiVisible,setConfettiVisible]=useState(false);
const [cartaActiva,setCartaActiva]=useState(false);
const [aDibujos, setADibujos]=useState(new Array());
const [aDibujos1, setADibujos1]=useState(["animales/caballo","animales/conejo","animales/elefante","animales/gato","animales/mariposa","animales/pajaro","animales/perro","animales/rana","animales/tortuga","animales/vaca"]);
const [aDibujos2, setADibujos2]=useState(["flores/amapola","flores/cactus","flores/campanilla","flores/grirasol","flores/lavanda","flores/lirio","flores/margarita","flores/pensamiento","flores/rosa","flores/tulipan"]);
const [aDibujos3, setADibujos3]=useState(["frutas/cereza","frutas/fresa","frutas/manzana","frutas/melocoton","frutas/naranja","frutas/pera","frutas/pina","frutas/platano","frutas/sandia","frutas/uvas"]);
const [aDibujos4, setADibujos4]=useState(["instrumentos/memoria_acordeon","instrumentos/memoria_flauta","instrumentos/memoria_guitarra","instrumentos/memoria_lira","instrumentos/memoria_maracas","instrumentos/memoria_piano","instrumentos/memoria_saxo","instrumentos/memoria_tambor","instrumentos/memoria_triangulo","instrumentos/memoria_xilofono"]);
const [aDibujos5, setADibujos5]=useState(["naturaleza/abeja","naturaleza/arbol","naturaleza/arcoiris","naturaleza/caracol","naturaleza/fogata","naturaleza/gota","naturaleza/hoja","naturaleza/montana","naturaleza/nube","naturaleza/seta","naturaleza/sol"]);
const [aDibujos6, setADibujos6]=useState(["transportes/avion","transportes/barco","transportes/camion","transportes/coche","transportes/globo_aeros","transportes/helicoptero","transportes/moto","transportes/submarino","transportes/tren","transportes/velero"]);

const [cartaSelect, setCartaSelect]=useState({ idDibujo: -1, mostrando: 0, solucionado:0});
const [iniciado, setIniciado] = useState(false);
const [matrix, setMatrix]= useState(Array(6).fill(0).map((row,index) =>      
    new Array(6).fill({ idDibujo: -1, mostrando: 0, solucionado:0}) 
))

  const audioWon = new Audio('./sounds/won.mp3');
  const audioOk = new Audio('./sounds/acierto.mp3');
  const audioWrong = new Audio('./sounds/error.mp3');
  const audioToca = new Audio('./sounds/toca_casilla.mp3');
  const [timerRunning, setTimerRunning] = useState<boolean>(false);
  const [secondsElapsed, setSecondsElapsed] = useState<number>(0);

  const [gameLost, setGameLost] = useState<boolean>(false);
  const [gameWon, setGameWon] = useState<boolean>(false);

  const [fraseSeleccionada, setFraseSeleccionada]=useState(""); 



  const today = new Date().toLocaleDateString('es-ES', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  }).toUpperCase();

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (timerRunning) {
      interval = setInterval(() => {
        setSecondsElapsed((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerRunning]);



if (!iniciado) {
   LeerDatos();
    IniciarParejas();
}



function shuffle(array:any) {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    let randomIndex = Math.floor(rand.next()* currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
}
function VoltearDibujosId(idDibujo:any){
  for(let col=0; col<6; col++){
    let columnaAct=matrix[col];
    for(let fil=0; fil<6; fil++){
      let casilla=columnaAct[fil];
      if(casilla.solucionado==0 && casilla.idDibujo==idDibujo){
        casilla.mostrando=1;
        casilla.solucionado=1;
      }
    }
  }

  let nMatrix = [...matrix];
    setMatrix(nMatrix);

    ComprobarTerminado();


}

 function RandomNumber(min: number, max: number): number {
    return Math.floor(rand.next()* (max - min + 1)) + min;
  }

  
function ComprobarTerminado(){
  let terminado=true;
  for(let col=0; col<6; col++){
    let columnaAct=matrix[col];
    for(let fil=0; fil<6; fil++){
      let casilla=columnaAct[fil];
      if(casilla.solucionado==0){
        terminado=false;
      }
    }
  }
  if(terminado){
    audioWon.play();
    setConfettiVisible(true);
    logEvent(analytics, 'parejas_terminado');
    setTimerRunning(false);
    SubirTiempo(secondsElapsed);

    setTimeout(() => {
        setGameWon(true);

        //Reiniciar(); // Iniciar fade (opacidad)
      }, 2000);
  }

}

 const formatClock = (totalSeconds: number): string => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };


  function PruebaAddData(){
    console.log("PruebaAddData");
    try {
      const docRef =  addDoc(collection(db, "todos"), {
        todo: 'hola',    
      });
      console.log("Document written with ID: ");
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  }




  function LeerDatos(){
    console.log("PruebaLeerData");

    const fetchPost = async () => {

        await getDocs(collection(db, "prueba"))
            .then((querySnapshot)=>{               
                const newData = querySnapshot.docs
                    .map((doc) => ({...doc.data(), id:doc.id }));
                //setTodos(newData);                
                console.log(newData);
            })

    }

    fetchPost();
    
  }

  const getTimes = async (tiempo: number) => {
    const docRef = doc(db, "tiempos_parejas", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate())
    const docSnap = await getDoc(docRef)
    let porcentajeS=0;
    if (docSnap.exists()) {
       console.log("Document data:", docSnap.data())
       let data=docSnap.data();

       let media=0;
       let contSuperado=0;

       for(var i=0; i<data.tiempos.length; i++){
          media=media+data.tiempos[i];
          if(data.tiempos[i]>=tiempo){
            contSuperado++;
          }
       }
       let medallaAct=0;
       media=media/data.tiempos.length;
       porcentajeS=(contSuperado/data.tiempos.length)*100;
       if(porcentajeS>=90){
        medallaAct=3;
       }else if(porcentajeS>=70){
        medallaAct=2;
       }else if(porcentajeS>=50){
        medallaAct=1;
       }else{
        medallaAct=0;
       }
       setMedalla(medallaAct);
       localStorage.setItem("medalla_parejas_"+fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate(),""+medallaAct);

       setPortentajeSuperado(porcentajeS);
       setMedia(media);
       console.log("Media -> "+media+" portentaje -> "+porcentajeS+" contSuperado ->"+contSuperado);
       data.tiempos.push(tiempo);
       setDoc(doc(db, "tiempos_parejas", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate()), data);


      //setUser(docSnap.data())
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
      const data = {
        tiempos:[tiempo]
      };
      localStorage.setItem("medalla_parejas_"+fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate(),""+3);
      porcentajeS=100;
      setDoc(doc(db, "tiempos_parejas", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate()), data);
      setMedalla(3);
      setMedia(tiempo);
      setPortentajeSuperado(100);
    }
    setFraseSeleccionada(ObtFraseFin(porcentajeS));
  }

  function SubirTiempo(tiempo: number){

    console.log("Subir tiempo-> "+tiempo);

    getTimes(tiempo);
    /*const data = {
      tiempo:[tiempo]
    };
    let docu=getDoc(doc(db, "tiempos_parejas", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate()));

    console.log(docu);

   setDoc(doc(db, "tiempos_parejas", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate()), data);*/
   

  }

function IniciarParejas() {

  const dayNames = ["Domingo", "Lunes", "Martes","Miércoles","Jueves","Viernes","Sabado"];
  let params = useParams();
  var today = new Date();
  //alert(today.toLocaleDateString('en-US'));
  //alert("Días "+params.dia);
  var numDias=parseInt(params.dia!);
  today.setDate(today.getDate() - numDias);
  setFechaAct(today);
  if(localStorage.getItem("medalla_parejas_"+today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate())==null){
    //alert("sin jugar");
  }else{
    //alert("Ya jugado "+localStorage.getItem("medalla_parejas_"+today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate()));
    
    setTimeout(function () {
            navigate("/dias/parejas");
    }, 50);
    
  }
  
  if(numDias==0){
    setFechaTexto("Hoy, "+today.getDate());
  }
  else if(numDias==1){
    setFechaTexto("Ayer "+today.getDate());
  }else{
    setFechaTexto(dayNames[today.getDay()] + " "+today.getDate());
  }
  //alert(today.toLocaleDateString('en-US'));
  rand=new Rand(today.toLocaleDateString('en-US'));
  
  let listaListaDibujos=new Array();
  listaListaDibujos.push(aDibujos1);
  listaListaDibujos.push(aDibujos2);
  listaListaDibujos.push(aDibujos3);
  listaListaDibujos.push(aDibujos4);
  listaListaDibujos.push(aDibujos5);
  listaListaDibujos.push(aDibujos6);
  let listaSelect=listaListaDibujos[Math.floor(rand.next() * listaListaDibujos.length)];
  console.log(listaSelect);
  setADibujos(listaSelect);
  shuffle(listaSelect);
  let maxDibujos=5+Math.floor(rand.next()* 4);
  let saDibujos=listaSelect.slice(0, maxDibujos);
  let aIndexDibujos=new Array();
  let nParejas=18;
  let cont1=0;
  for(var i=0;i<nParejas;i++){
    aIndexDibujos.push(cont1);
    aIndexDibujos.push(cont1);
    cont1++;
    if(cont1>=saDibujos.length){
        cont1=0;
    }
  }

  
  shuffle(aIndexDibujos);

  console.log(aIndexDibujos);

  let nMatrix = [...matrix];
  let cont=0;
  

  for(let col=0; col<6; col++){
    let columnaAct=matrix[col];
    for(let fil=0; fil<6; fil++){
      let casilla=columnaAct[fil];
      casilla={ idDibujo: aIndexDibujos[cont], mostrando: 0, solucionado:0};
      columnaAct[fil]=casilla;
      cont++;
      
    }
    matrix[col]=columnaAct;
  }
  setIniciado(true);
  setTimerRunning(true);
}

function Continuar(){
    //window.location.reload();
    navigate("/dias/parejas");
  }

function ClickCarta(carta:any){
  console.log(cartaSelect);
  console.log(carta.mostrando);
  audioToca.play();
  
  

  if(carta.mostrando==0){
    carta.mostrando=1;

    if(cartaActiva==false){
      setCartaSelect(carta);
      setCartaActiva(true);
    }else{
      if(cartaSelect.idDibujo==carta.idDibujo){
        cartaSelect.solucionado=1;
        carta.solucionado=1;
        

        setTimeout(function () {
            audioOk.play();
            VoltearDibujosId(carta.idDibujo);


        }, 500);


      }else{

        setTimeout(function () {
            audioWrong.play();
            carta.mostrando=0;
            cartaSelect.mostrando=0;
            let nMatrix = [...matrix];
            setMatrix(nMatrix);


        }, 1000);

        
      }
      setCartaActiva(false);
    }
    

    let nMatrix = [...matrix];
    setMatrix(nMatrix);

  }

  
}

function ClickBack(){
  //navigate("/dias/parejas");
  AbrirLateral();
}

function AbrirLateral(){
    document.getElementById("lateral-juegos")!.style.left = "0px";
    document.getElementById("lateral-juegos")!.style.boxShadow = "4px 0 20px rgba(0,0,0,0.08)";
    document.getElementById("lateral-overlay")!.style.opacity = "1";
    document.getElementById("lateral-overlay")!.style.pointerEvents = "auto";
  }


 return (
    <div className={"puzztime " + juegoAct.nombre}>
     

      {/* --------------------- HEADER --------------------- */}

      <Header nombre={juegoAct.nombre} color={juegoAct.color} clicked={() => ClickBack()} ></Header>




      <div className="game-area">
      {/* --------------------- GAME META --------------------- */}

      <TiemposCont fechaTexto={fechaTexto} secondsElapsed={formatClock(secondsElapsed)}></TiemposCont>

    {/* --------------------- GAME CONTENT --------------------- */}

    <main className="game-content">
      <div className='cartas'>
      {matrix.map((row, index) => (
          <div className="rowCartas" key={index}>
            {row.map((carta, index2) => (
                <Carta carta={carta} aDibujos={aDibujos} index2={index2} clicked={() => ClickCarta(carta)}></Carta>
            ))}
          </div>
          ))}
          </div>
      </main>

        {/* Mensaje de victoria */}
        {gameWon &&(
          <Victoria
            nombre={juegoAct.nombre}
            color={juegoAct.color}
            today={today}
            fraseSeleccionada={fraseSeleccionada}
            secondsElapsed={formatClock(secondsElapsed)}
            medalla={medalla}
            media={media}
            porcentajeSuperado={porcentajeSuperado}
            clickContinuar={Continuar}
            icono={juegoAct.icono}
            idJuego={2}
            ></Victoria>
          )}
      </div>

      {confettiVisible && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999, pointerEvents: 'none' }}>
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={200}
          gravity={0.05}
          recycle={false}
          initialVelocityY={15}
          colors={['#8CB3F3', '#CEA3FF', '#FA6F68', '#FBCB5F', '#A0C95D']}
          drawShape={ctx => {
            const width = 15;
            const height = 8;
            const radius = 3;
            ctx.beginPath();
            ctx.moveTo(radius, 0);
            ctx.arcTo(width, 0, width, height, radius);
            ctx.arcTo(width, height, 0, height, radius);
            ctx.arcTo(0, height, 0, 0, radius);
            ctx.arcTo(0, 0, width, 0, radius);
            ctx.closePath();
            ctx.fill();
          }}
        />
        </div>
      )}
        

        
        <AbajoJuegos idJuegoAct={2} diaActual={parseInt(params.dia!)}></AbajoJuegos>
    </div>

    
  )
}

export default Parejas;
